import { createSlice } from "@reduxjs/toolkit";
import { LoadState } from "../types/commonTypes";
import { Job } from "../types/jobTypes";
import jobsApi from "../api/jobsApi";
import { DateTime } from "luxon";

interface JobsState {
  loadState: LoadState;
  jobs: Job[];
  createLoadState: LoadState;
}

const initialState: JobsState = {
  loadState: LoadState.INIT,
  jobs: [],
  createLoadState: LoadState.INIT,
};

export const JobSlice = createSlice({
  name: "JobState",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(jobsApi.endpoints.getJobs.matchPending, (state) => {
        state.loadState = LoadState.LOADING;
      })
      .addMatcher(
        jobsApi.endpoints.getJobs.matchFulfilled,
        (state, { payload }) => {
          state.loadState = LoadState.LOADED;
          state.jobs = payload;
        }
      )
      .addMatcher(jobsApi.endpoints.getJobs.matchRejected, (state) => {
        state.loadState = LoadState.ERROR;
      })
      .addMatcher(jobsApi.endpoints.adminGetJobs.matchPending, (state) => {
        state.loadState = LoadState.LOADING;
      })
      .addMatcher(
        jobsApi.endpoints.adminGetJobs.matchFulfilled,
        (state, { payload }) => {
          state.loadState = LoadState.LOADED;
          state.jobs = payload;
        }
      )
      .addMatcher(jobsApi.endpoints.adminGetJobs.matchRejected, (state) => {
        state.loadState = LoadState.ERROR;
      })
      .addMatcher(jobsApi.endpoints.createJob.matchPending, (state) => {
        state.createLoadState = LoadState.LOADING;
      })
      .addMatcher(
        jobsApi.endpoints.createJob.matchFulfilled,
        (state, { payload }) => {
          state.createLoadState = LoadState.LOADED;
          state.jobs = [...state.jobs, payload];
        }
      )
      .addMatcher(jobsApi.endpoints.createJob.matchRejected, (state) => {
        state.createLoadState = LoadState.ERROR;
      });
  },
});

export default JobSlice.reducer;
